import * as types from '../../constants/canvas/ResultActionTypes'
import {env} from '../../constants/Environment';
import _ from 'lodash';

export function loadVersions(firestore, channel, latestDateRead){
	return function(dispatch){
        dispatch({
            type: types.REQUESTED_VERSIONS,
            channel: channel
        });

        return (new Promise((resolve, reject) => {				
				(async () => {
                     if(typeof latestDateRead === null)
                        latestDateRead = new Date();

                    let q = firestore.collection('environments/' + env + '/canvas/' + channel + '/mappings/results/versions').orderBy('created').limit(10).startAfter(latestDateRead);
                    q.onSnapshot((snapshot) => {
                        let results = {};

                        if(!snapshot.empty){
                            snapshot.forEach((doc) => {
                                results[doc.id] = doc.data();
                            });
                        }

                        dispatch({
                            type: types.RECEIVED_VERSIONS,
                            versions: results,
                            channel: channel
                        });
                        resolve();
                    });
                })();
			}));
    }
}

function cleanEntry(entry){
    if(typeof entry.conditions !== 'undefined')
        entry.conditions = _.reject(entry.conditions, (condition) => condition.length === 0);
    if(typeof entry.fields !== 'undefined')
        entry.fields = _.filter(entry.fields, (field) => {
            if(typeof field === 'object'){
                if(field.type === 'rule' && field.value.length === 0)return false;
            }else if(field.length === 0)
                return false;
            return true;
        });

    return entry;
}

export function saveDraft(firestore, channel, data){
	return function(dispatch){
        dispatch({
            type: types.REQUESTED_SAVE,
            channel: channel
        });

        return (new Promise((resolve, reject) => {				
				(async () => {

                    let mappings = {};
                    if(typeof data.mappings !== 'undefined'){
                        mappings = _.cloneDeep(data.mappings);

                        for(let key in mappings){
                            if(Array.isArray(mappings[key])){
                                for(let idx in mappings[key]){
                                    mappings[key][idx] = cleanEntry(mappings[key][idx]);
                                }
                            }else{
                                mappings[key] = cleanEntry(mappings[key]);
                            }
                        }
                    }
                    
                    let ref = await firestore.collection('environments/' + env + '/canvas/' + channel + '/mappings/results/versions').add({
                        mappings: mappings, 
                        created: new Date()
                    });
                    
                    let snapshot = await ref.get();

                    dispatch({
                        type: types.DONE_SAVE,
                        data: snapshot.data(),
                        id: ref.id,
                        channel: channel
                    });
                })();
			}));
    }
}

export function publish(firebase, channel, draftId){
	return function(dispatch){
        dispatch({
            type: types.TRIGGER_PUBLISH,
            id: draftId,
            channel: channel
        });

        let user = firebase.auth().currentUser.uid;
        let firestore = firebase.firestore();

        return (new Promise((resolve, reject) => {				
				(async () => {
                    let firestore = firebase.firestore();

                    let doc = {
                        cmd: 'PUBLISH',
                        scope: 'results',
                        data: {
                            id: draftId
                        },
                        user: user,
                        created: new Date()
                    };
                    await firestore.collection('environments/' + env + '/canvas/' + channel + '/commands').add(doc);

                    resolve();
                })();
			}));
    }
}

export function createDraftFrom(channel, srcId){
	return {
        type: types.CREATE_DRAFT,
        channel: channel,
        src: srcId
    }
}

export function cancelCreateDraft(channel){
	return {
        type: types.CANCEL_CREATE_DRAFT,
        channel: channel
    }
}

export function editRule(channel, ruleKey){
	return {
        type: types.EDIT_RULE,
        key: ruleKey,
        channel: channel
    }
}

export function updateRuleField(channel, ruleKey, field, val){
	return {
        type: types.SET_VALUE,
        key: ruleKey,
        field: field,
        value: val,
        channel: channel
    }
}